import React from 'react';

// Utility functions
function formatDate(dateString) {
     // Expects 'yyyy-mm-dd hh:mm:ss'
     const [datePart] = dateString.split(' ');
     const [year, month, day] = datePart.split('-');
     return `${day}-${month}-${year}`;
}

function formatTime(dateString) {
     // Expects 'yyyy-mm-dd hh:mm:ss'
     const [, timePart] = dateString.split(' ');
     if (!timePart) return '';
     const [hour, minute] = timePart.split(':');
     return `${hour}:${minute}`;
}

// Reusable components
export function FormattedDate({ value }) {
     return <span>{formatDate(value)}</span>;
}

export function FormattedTime({ value }) {
     return <span>{formatTime(value)}</span>;
}